import { createSelector } from 'reselect'
import { AppState } from 'store/store'

/**
 *
 * @param state - the application state
 * @returns
 */
export const selectSelectedShiftGigAutoAcceptCertificatesReducer = (state: AppState) =>
  state.selectedShiftGigAutoAcceptCertificates

/**
 * Gets the SelectedShiftGigAutoAcceptCertificates array from the SelectedShiftGigAutoAcceptCertificates reducer
 */
export const selectSelectedShiftGigAutoAcceptCertificates = createSelector(
  selectSelectedShiftGigAutoAcceptCertificatesReducer,
  (SelectedShiftGigAutoAcceptCertificatesState) => SelectedShiftGigAutoAcceptCertificatesState.data
)

/**
 * Gets the SelectedShiftGigAutoAcceptCertificates' isFetching from the SelectedShiftGigAutoAcceptCertificates reducer
 */
export const selectSelectedShiftGigAutoAcceptCertificatesIsFetching = createSelector(
  selectSelectedShiftGigAutoAcceptCertificatesReducer,
  (SelectedShiftGigAutoAcceptCertificatesState) =>
    SelectedShiftGigAutoAcceptCertificatesState.isFetching
)

/**
 * Gets the SelectedShiftGigAutoAcceptCertificates' meta from the SelectedShiftGigAutoAcceptCertificates reducer
 */
export const selectSelectedShiftGigAutoAcceptCertificatesMeta = createSelector(
  selectSelectedShiftGigAutoAcceptCertificatesReducer,
  (SelectedShiftGigAutoAcceptCertificatesState) => SelectedShiftGigAutoAcceptCertificatesState.meta
)

/**
 * Gets the SelectedShiftGigAutoAcceptCertificates' error from the SelectedShiftGigAutoAcceptCertificates reducer
 */
export const selectSelectedShiftGigAutoAcceptCertificatesError = createSelector(
  selectSelectedShiftGigAutoAcceptCertificatesReducer,
  (SelectedShiftGigAutoAcceptCertificatesState) => SelectedShiftGigAutoAcceptCertificatesState.error
)
